import React from "react";
import { FiDownload } from "react-icons/fi";
import { useEDADashboard } from "./useEDADashboard";
import DashboardHeader from "./components/DashboardHeader";
import SummaryCards from "./components/SummaryCards";
import DonutCharts from "./components/DonutCharts";
import TrendChart from "./components/TrendChart";

const EDADashboard = () => {
  const {
    navigate,
    location,
    currentMonth,
    selectedMonth,
    setSelectedMonth,
    months,
    selectedYear,
    setSelectedYear,
    dashboardData,
    loading,
    error,
    dashboard,
    selectedProcess,
    title,
    selectedMonthLabel,
    consolidatedReport,
    trendChartOption,
  } = useEDADashboard();

  return (
    <div className="space-y-5">
      <DashboardHeader
        title={title}
        selectedProcess={selectedProcess}
        dashboard={dashboard}
        navigate={navigate}
        location={location}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        loading={loading}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        months={months}
        currentMonth={currentMonth}
        selectedMonthLabel={selectedMonthLabel}
      />

      {location.state && (
        <>
          {error && (
            <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
              {error}
            </div>
          )}

          <SummaryCards
            cards={dashboardData.summaryCards}
            loading={loading}
            navigate={navigate}
            selectedProcess={selectedProcess}
            dashboard={dashboard}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
          />
          
          <DonutCharts sections={dashboardData.donutSections} loading={loading} />
          
          <TrendChart trendChartOption={trendChartOption} loading={loading} />

          {consolidatedReport && (
            <div className="flex justify-end">
              <a
                href={consolidatedReport.xlsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-[#0060D0] px-4 py-2 text-sm font-semibold !text-white shadow-sm transition hover:bg-[#0050b0]"
              >
                <FiDownload className="h-4 w-4" />
                Download Final Consolidated Report
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EDADashboard;
